import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { useAnimatedScroll } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/useAnimatedScroll";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useGetBrandValues } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/useGetBrandValues";
import { BrandValueBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/BrandValueBanner";
import {
  ITabProps,
  PillWithContent,
} from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/__internal__/PillWithContentComponent/PillWithContent";
import { BrandValueBannerBrandInfo } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/BrandValueBannerV2/__internal__/BrandValueBannerBrandInfo";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
import { getSpacing } from "@faire/web--source/slate/spacing";
import * as React from "react";

import { useIsLoggedOutHomepageV2 } from "../../../useIsLoggedOutHomepageV2";

export const BrandValueBannerWithV2Design: React.FC = () => {
  const isHomepageRedesignV2 = useIsLoggedOutHomepageV2();
  if (isHomepageRedesignV2) {
    return <BrandValueBannerV2 />;
  }
  return (
    <SlideIn offset={getSpacing("5x")}>
      <BrandValueBanner />
    </SlideIn>
  );
};

const BrandValueBannerV2: React.FC = () => {
  const brandValues = useGetBrandValues();
  const { strictLocalize } = useStrictLocalization();
  const {
    resumeScroll,
    pauseScroll,
    isVisible,
    currentIndex,
    setCurrentIndex,
  } = useAnimatedScroll(brandValues?.length ?? 0, 5000);

  const tabs: Array<ITabProps> =
    brandValues?.map(({ name, id }) => {
      return {
        tabName: name,
        pathIdentifier: id,
        ctaLink: undefined,
        ctaLinkText: undefined,
      };
    }) ?? [];

  return (
    <PillWithContent
      title={strictLocalize({
        defaultMessage: "Shop by your values",
        description: {
          text: "brand value banner header",
          img: "https://cdn.faire.com/fastly/2deff5acbb77a76b253f8e88956a48ef2de702f15d30a489d00f4c747f784008.png",
        },
      })}
      tabs={tabs}
      eventTrackingName="brand_value_banner"
      pauseScroll={pauseScroll}
      resumeScroll={resumeScroll}
      currentIndex={currentIndex}
      setCurrentIndex={setCurrentIndex}
      isVisible={isVisible}
    >
      {isRobot() ? (
        <>
          {/* we want to prerender all brand values */}
          {brandValues.map((brandValue, index) => (
            <BrandValueBannerBrandInfo
              key={index}
              brandInfo={brandValue.brand}
              className={index ? "invisible h-0 p-0!" : ""}
            />
          ))}
        </>
      ) : (
        <BrandValueBannerBrandInfo
          brandInfo={brandValues[currentIndex]?.brand}
        />
      )}
    </PillWithContent>
  );
};
